import CONST from '../../../../../includes/primitives/_constant_trion'
import Defs from '../../../../../includes/primitives/colorDefs'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
        
    canvasForm: null,
    canvasContents: null,
    rawData:    null,
    filterData: null,

    area:       null,
    table:      null,
    columns:    null,
    scroll:     null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {
      let lightBlue = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `shadowTimeline`).attr('x1', 0.5).attr('x2', 0.5).attr('y2', 1)
      lightBlue.append('stop').attr('stop-color', '#3d3d3d').attr('offset', '0').attr('stop-opacity', 0.5)
      lightBlue.append('stop').attr('stop-color', '#fff').attr('offset', '1').attr('stop-opacity', 0.3)

      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightGray', [ 0.5, 1.0, 0.5, -0.2], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightBlue', [.5, .8, .5, 0], this.localId)

    },

  }
}